import { AmexMedium } from '../assets/credit-cards/amex-medium'
import { AmexSmall } from '../assets/credit-cards/amex-small'
import { DinersClubMedium } from '../assets/credit-cards/diners-club-medium'
import { DinersClubSmall } from '../assets/credit-cards/diners-club-small'
import { EloMedium } from '../assets/credit-cards/elo-medium'
import { EloSmall } from '../assets/credit-cards/elo-small'
import { HipercardMedium } from '../assets/credit-cards/hipercard-medium'
import { HipercardSmall } from '../assets/credit-cards/hipercard-small'
import { MastercardMedium } from '../assets/credit-cards/mastercard-medium'
import { MastercardSmall } from '../assets/credit-cards/mastercard-small'
import { UndefinedMedium } from '../assets/credit-cards/undefined-medium'
import { UndefinedSmall } from '../assets/credit-cards/undefined-small'
import { VisaMedium } from '../assets/credit-cards/visa-medium'
import { VisaSmall } from '../assets/credit-cards/visa-small'
import type { CreditCardFlagsProps } from '../flags.types'

const CreditCardFlags = (props: CreditCardFlagsProps) => {
  if (!props.variant)
    return props.size === 'sm' ? <UndefinedSmall /> : <UndefinedMedium />

  if (props.size === 'sm')
    switch (props.variant) {
      case 'amex':
        return <AmexSmall />
      case 'diners-club':
        return <DinersClubSmall />
      case 'elo':
        return <EloSmall />
      case 'hypercard':
        return <HipercardSmall />
      case 'mastercard':
        return <MastercardSmall />
      case 'visa':
        return <VisaSmall />
    }

  switch (props.variant) {
    case 'amex':
      return <AmexMedium />
    case 'diners-club':
      return <DinersClubMedium />
    case 'elo':
      return <EloMedium />
    case 'hypercard':
      return <HipercardMedium />
    case 'mastercard':
      return <MastercardMedium />
    case 'visa':
      return <VisaMedium />
  }
}

export default CreditCardFlags
